<era-master-detail flexGrowLeft="2"
                   flexGrowRight="3">
  <era-master>
    <era-panel>
      <era-title>
        <span title
              i18n>Permissions</span>
      </era-title>
      <era-groups-permissions-entity-list></era-groups-permissions-entity-list>
    </era-panel>
  </era-master>
</era-master-detail>